const house_sec1_part1Location = (payload) => {
  return {
    type: "housesec1part1loc",
    payload,
  };
};

export default house_sec1_part1Location;
